/**
 * @file clear
 * @author xuemin02
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import OutlinedCloseBold from 'acud-icon/lib/icons/OutlinedCloseBold';
import { ConfigContext } from '../config-provider';
const Clear = (props) => {
    const { prefixCls: customizePrefixCls, className } = props, otherProps = __rest(props, ["prefixCls", "className"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('clear', customizePrefixCls);
    const clearCls = classnames(prefixCls, className);
    return <OutlinedCloseBold className={clearCls} {...otherProps}/>;
};
export default Clear;
